import * as React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import {
  Breadcrumb as BreadcrumbUI,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import type { Breadcrumb as Interface } from '../../design/components';

/**
 * Breadcrumb - shadcn/ui implementation
 * Shows: Home icon > crumbs[0] > crumbs[1] > ...
 */
export const Breadcrumb: React.FC<Interface> = ({ crumbs = [] }) => {
  // Capitalize first letter for display
  const formatName = (name: string) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  // Build path for each crumb
  const buildPath = (index: number) => '/' + crumbs.slice(0, index + 1).join('/');

  return (
    <BreadcrumbUI>
      <BreadcrumbList>
        <BreadcrumbItem>
          {crumbs.length === 0 ? (
            <BreadcrumbPage className="flex items-center gap-1">
              <Home className="h-4 w-4" />
              <span className="sr-only sm:not-sr-only">Home</span>
            </BreadcrumbPage>
          ) : (
            <BreadcrumbLink asChild>
              <Link to="/" className="flex items-center gap-1">
                <Home className="h-4 w-4" />
                <span className="sr-only sm:not-sr-only">Home</span>
              </Link>
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>

        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          const isModel = index === 0;

          return (
            <React.Fragment key={index}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{isModel ? formatName(crumb) : crumb}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={buildPath(index)}>{isModel ? formatName(crumb) : crumb}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </BreadcrumbUI>
  );
};
